var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00529 55.1824C3.02224 55.1664 3.03926 55.1503 3.05634 55.1342C4.6125 53.6632 6.72311 51.58 8.94068 49.1306C13.3505 44.2597 18.2792 37.8382 20.0122 31.8628C21.7451 25.8873 21.0166 17.8252 19.897 11.3508C19.3339 8.09495 18.6654 5.20573 18.1376 3.13044C18.112 3.02976 18.0868 2.931 18.0618 2.83418C18.1303 2.90703 18.2002 2.98122 18.2716 3.05671C19.7425 4.61288 21.8258 6.72349 24.2752 8.94106C29.1461 13.3508 35.5675 18.2796 41.543 20.0125C47.5185 21.7455 55.5807 21.017 62.055 19.8974C65.3109 19.3343 68.2001 18.6658 70.2754 18.138C70.2982 18.1322 70.3208 18.1264 70.3434 18.1207C70.3074 18.1524 70.2712 18.1845 70.2346 18.2168C68.5982 19.6646 66.3804 21.7172 64.0554 24.1361C59.4345 28.9436 54.2807 35.3085 52.544 41.2971C50.8072 47.2857 51.7561 55.4204 53.088 61.9542C53.7456 65.1805 54.5048 68.0534 55.1074 70.1429C53.6645 68.5158 51.6436 66.3374 49.2697 64.0557C44.4622 59.4348 38.0973 54.2811 32.1087 52.5443C26.12 50.8076 17.9854 51.7565 11.4515 53.0883C8.16406 53.7584 5.2434 54.534 3.14472 55.1419C3.09783 55.1555 3.05135 55.169 3.00529 55.1824Z",
    fill: "white",
    stroke: "#674EDD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSymbol);
export default __webpack_public_path__ + "static/media/star-symbol.48d6104a97c89cc968c19bb79f77232d.svg";
export { ForwardRef as ReactComponent };